import { useLocation } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";

/**
 * Custom hook to detect current route/pathname and return boolean flags
 * for different route types. Centralizes all route detection logic.
 */
export const useRouteDetection = () => {
  const { pathname } = useLocation();

  const isLegalChatbot =
    pathname.includes(ROUTE_NAMES.LEGAL_CHATBOT) ||
    pathname?.startsWith("/chat");

  const isMultiDoc = pathname.includes(ROUTE_NAMES.CHECKLIST);
  const isMultiDocDashboard = pathname === ROUTE_NAMES.CHECKLIST;
  const isKcs = pathname.includes(ROUTE_NAMES.KCS);
  const isDrawingAnalysis = pathname.startsWith(ROUTE_NAMES.DRAWING_ANALYSIS);
  const isProjectDocument =
    pathname.includes(ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT) ||
    pathname.includes("/document-chat");

  return {
    pathname,
    isLegalChatbot,
    isMultiDoc,
    isMultiDocDashboard,
    isKcs,
    isDrawingAnalysis,
    isProjectDocument,
  };
};
